import React, { Component } from 'react'
import { message } from 'antd'
import store from '../../../redux/store'
class Registration extends Component {
  componentDidMount() {
    message.info('暂未开放！敬请期待！', 3)
    store.dispatch({
      type: 'CHANGE_NAV',
      payload: '仲裁员年度注册'
    })
  }
  render() {
    return <div></div>
  }
}
export default Registration